"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (obj, updates) {
    var finalUpdates = getUpdates(updates);
    return (0, _immutabilityHelper2.default)(obj, finalUpdates);
};

var _immutabilityHelper = require("immutability-helper");

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var keyReg = /^(\w+)( ?(.+))?$/i;

var ACTIONS = {
    "set": "set",
    "unsetPropsOn": "unset",
    "push": "push",
    "unshift": "unshift",
    "togglePropsOn": "toggle",
    "apply": "apply",
    "merge": "merge",
    "splice": "splice"
};

var createObjectFromArray = function createObjectFromArray(path, value) {
    var ret = {};
    var tmp = {};

    var len = path.length;

    if (!len) return value;

    for (var i = 0; i < len; i++) {
        if (i == 0) tmp = ret[path[i]] = i + 1 === len ? value : {};else tmp = tmp[path[i]] = i + 1 === len ? value : {};
    }

    return ret;
};

var getValue = function getValue(action, value) {
    var ret = {};

    ret["$" + action] = value;

    return ret;
};
var serializeKey = function serializeKey(key) {
    var match = key.toString().match(keyReg);

    if (!match) return {
        action: null,
        path: null
    };

    return {
        action: ACTIONS[match[1]],
        path: match[3] ? match[3].split(".") : null
    };
};

/*
//Copy all of this over into tests later

const testData = {
    x:{
        y:{
            z:null,
            o:5
        },
        d:false
    },
    a:{
        b:[1,2,3]
    }
}


const log = (str,result)=>{
    console.log(`Easy Update - ${str}`,result);
}

log("set",
    EasyUpdate(testData,{
        "set x.y.z":7
    })
)

log("push",
    EasyUpdate(testData,{
        "push a.b":[9]
    })
)

log("unshift",
    EasyUpdate(testData,{
        "unshift a.b":[2]
    })
)

log("togglePropsOn",
    EasyUpdate(testData,{
        "togglePropsOn x":["d"]
    })
)
log("unsetPropsOn",
    EasyUpdate(testData,{
        "unsetPropsOn x":['d']
    })
)

log("apply",
    EasyUpdate(testData,{
        "apply x.y.o":(node)=> node * 2
    })
)

log("merge",
    EasyUpdate(testData,{
        "merge x.y":{k:"new"}
    })
)

log("splice",
    EasyUpdate(testData,{
        "splice a.b":[[1,1,4]]
    })
)
*/
var getUpdates = function getUpdates(updates) {
    var finalUpdate = {};

    Object.keys(updates).forEach(function (key) {
        var output = serializeKey(key);

        var action = output.action;
        var path = output.path;

        if (!action) {
            console.warn("EasyUpdate - Unable to find action", key);
            return null;
        }
        if (!path) {
            return finalUpdate = Object.assign(finalUpdate, createObjectFromArray("", getValue(action, updates[key])));
        }

        var initialProp = path.shift();

        if (initialProp === "") initialProp = path.shift();

        if (finalUpdate[initialProp]) {
            return finalUpdate[initialProp] = Object.assign(finalUpdate[initialProp], createObjectFromArray(path, getValue(action, updates[key])));
        }
        finalUpdate[initialProp] = createObjectFromArray(path, getValue(action, updates[key]));
    });

    return finalUpdate;
};